import api from '@/api'

const SET_FOODER = 'SET_FOODER'

export default {
  namespaced: true,

  state () {
    return {
      loaded: false,
      fooder: []
    }
  },

  getters: {
    loaded: (state) => state.loaded,
    fooder: (state) => state.fooder,
    totalCount: (state) => state.totalCount
  },

  mutations: {
    [SET_FOODER] (state, data) {
      state.fooder = data
      state.loaded = true
    }
  },

  actions: {
    async loadFooder (context, params = {}) {
      // manager/stock/ ???
      const { data } = await api.stocks.list(params)
      context.commit(SET_FOODER, data)
    }
  }
}
